<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12Oern8/tc-custom/9798886937725.jpg?1725723409087" alt="This image is the cover for the book March on the Arch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">March on the Arch
      </h1>
      <p class="bookDescription body article font2">
        <p>Andi and Tony find themselves reduced in size to just nine inches tall. Mom and Dad have disappeared. What’s happening? Andi believes they must hike up the mountain behind their home, up to the monument known as the ‘Arch,’ to solve the mystery. </p><p>Being small makes everything so different! Mom’s garden, the fields, the woods, once so familiar, are transformed into a world of magic and danger. </p><p>Along the way, fun, friends, and surprises await. Brother and sister will need all of their courage and wits on their quest to save themselves, their folks, and even the planet. </p><p>Join them on this fantastic adventure filled with laughter and excitement!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea J. Adams
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Andrea Adams grew up in a small town free to play and roam the fields and woods till dark. The author lives with her husband in Exeter, New Hampshire.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fb2f5450